const routes = [
  {
    name: "core",
    path: "/dashboard",
    component: () => import("@/views/app/dashboard/Start")
  },
  {
    path: "/dashboard/result/work_orders",
    component: () => import("@/views/app/dashboard/wo_search_t1_pages/wo_list")
  },
  // ! Sadece test için burada, sonradan silinecek
  {
    path: 'form-builder-test',
    component: () => import('@/views/app/pages/form-builder-test')
  },
  {
    path: 'discount-form',
    component: () => import('@/views/app/pages/form-builder-test/discount-form.vue')
  },
];

export default routes;
